// Copying a line to the clipboard: a recording's timestamp link, a prompt, a certificate's check
// link. The Clipboard API first; where a browser refuses it (an older Safari, or a page without
// focus), a hidden text box and the copy command. Resolves true once copied, false if neither worked.
export async function copyText(text) {
  try {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(text)
      return true
    }
  } catch { /* fall through to the old way */ }
  try {
    const box = document.createElement('textarea')
    box.value = text
    box.setAttribute('readonly', '')
    box.style.position = 'fixed'
    box.style.top = '-1000px'
    box.style.opacity = '0'
    document.body.appendChild(box)
    box.select()
    const ok = document.execCommand('copy')
    box.remove()
    return Boolean(ok)
  } catch {
    return false
  }
}
